import React from 'react';
import { SUMMARY } from '../../data/collection';

/** Brief at-a-glance band right under the hero. */
export function SummaryStrip() {
  return <section aria-label="Resumen de la colección" className="w-full border-y border-blush-deep bg-blush" data-id="element-280" data-mp="c8b8i5h8hcp1">
      <ul className="mx-auto grid max-w-6xl grid-cols-2 px-5 sm:px-8 md:grid-cols-4" data-id="element-281" data-mp="3tlezw4kh0bah">
        {SUMMARY.map((item, index) => <li key={item.label} className={`flex flex-col items-center justify-center py-6 text-center md:py-7 ${index % 2 === 1 ? 'border-l border-dashed border-coral/40' : ''} ${index >= 2 ? 'border-t border-dashed border-coral/40 md:border-t-0' : ''} ${index === 2 ? 'md:border-l' : ''}`} data-id="element-282" data-mp="q7141goen4ba" data-mpi={index}>
            <span className="font-serif text-[1.9rem] font-semibold leading-none text-coral-ink sm:text-[2.2rem]" data-id="element-283" data-mp="l9j1c80zdlbq">
              {item.value}
            </span>
            <span className="mt-1.5 text-[0.95rem] font-semibold text-graphite" data-id="element-284" data-mp="35zgvskp6yqjb">{item.label}</span>
          </li>)}
      </ul>
    </section>;
}